module.exports = __webpack_public_path__ + "static/media/subscription.e801061a.svg";